import React from 'react';
import styled from 'styled-components';
import MypageMenu from '../components/menus/MypageMenu'; // 새로 만든 메뉴 컴포넌트
import Banner from '../components/Banner'; // 기존의 배너 컴포넌트
import FooterComponent from '../components/FooterComponent';
import BreadcrumbComponent from '../components/BreadcrumbComponent';
import { useParams } from 'react-router-dom';

const MypageLayout = ({ children }) => {
  const { section } = useParams(); // URL에서 'section' 파라미터를 가져옵니다.
  const breadcrumb = ['홈', '마이페이지'];
  // 경로에 따라 breadcrumb 설정
  if (section === 'edit') {
    breadcrumb.push('정보수정');
  }
  return (
    <>
      <Banner title="회원관리" description="" />
      <BreadcrumbComponent items={breadcrumb} />
      <LayoutContainer>
        <SideMenu>
          <MypageMenu />
        </SideMenu>
        <MainContent>{children}</MainContent>
      </LayoutContainer>
      <FooterComponent />
    </>
  );
};

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 120px;

  @media (max-width: 480px) {
    flex-direction: column;
    margin: 0;
  }
`;

const SideMenu = styled.div`
  /* flex-basis: 250px; */
  width: 250px;
  /* padding: 20px; */
  /* border-right: 1px solid #ddd; */

  @media (max-width: 480px) {
    flex-basis: 100%;
    border-right: none;
    /* border-bottom: 1px solid #ddd; */
  }
`;

const MainContent = styled.main`
  flex: 1;
  /* width: 100%; */
  /* padding: 20px; */

  @media (max-width: 480px) {
    /* padding: 10px; */
  }
`;

export default MypageLayout;
